import uniqueId from '@form-create/utils/lib/unique';
import { makeOptionsRule, makeRequiredRule } from '../../utils';
var label = '状态开关';
var name = 'switchStatus';
export default {
  icon: 'iconfont iconxuanzeqi',
  label: label,
  name: name,
  rule: function rule() {
    return {
      type: name,
      field: uniqueId(),
      title: label,
      info: '',
      effect: {
        fetch: ''
      },
      props: {
        activeText: '',
        inactiveText: '',
        value: false,
        name: ''
      },
      checkType: 0
    };
  },
  props: function props() {
    return [makeOptionsRule('props'), makeRequiredRule()];
  },
  basic: function basic() {}
};